import buyContactForm from './../modules/buyContactForm';
buyContactForm();
// FUNÇÕES/MÓDULOS SITE
window.onload = () => {
    /*
    Sumary
        1 - Adjustment footer margin
        2 - Animation
    */

 
    /************************** 1 - Adjustment footer padding *****************/

    if (window.screen.width > 1150) {
        const footer = document.querySelector('footer')
        footer.style.padding = '77px 0px 37px 0px'
        footer.style.marginTop= '0px'
    }

    /************************** 2 - Animation *****************/
    const titleBanner = document.querySelector('#buy-page .section-banner h1')
    TweenMax.from(titleBanner, 1, {
        x: -100,
        opacity: 0,
    })
    /////////
    const titleForms = document.querySelector('#buy-page .section-buy .description')
    TweenMax.from(titleForms, 1, {
        x: -100,
        opacity: 0,
    })
    const forms = document.querySelector('#buy-page .section-buy .contact-info')
    TweenMax.from(forms, 1, {
        x: 100,
        opacity: 0,
    })

}


